import axios from 'axios'
const urlbase =
  process.env.VUE_APP_API_SERVER_QEC ?? 'https://testapidev.co/api/v1/qec/'

export const qecAxios = axios.create({
  baseURL: urlbase,
  headers: {
    'content-type': 'application/json',
    accept: 'application/json',
    'X-meli-session-id': window.MP_DEVICE_SESSION_ID,
  },
})

export default qecAxios
